export const Config = {
  basePath: 'http://api.scs.noi.top',
  // basePath: 'http://localhost:5008',
  ossPrefix: 'https://scs-official.oss-cn-hangzhou.aliyuncs.com',
  version: '1.0.0',
};
